import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';
import { resolveAssetUrl } from "../../../utils/assetUrl";

const resolveProductImageUrl = (imageUrl) => {
    if (!imageUrl) return undefined;
    const value = String(imageUrl);
    if (value.startsWith("data:") || value.startsWith("blob:") || /^(?:[a-z]+:)?\/\//i.test(value)) {
        return resolveAssetUrl(value);
    }
    return resolveAssetUrl(`/uploads/${value.replace(/^\/?uploads\//, "")}`);
};

export default function ProductGrid({ products, onEdit, onDelete, onPreviewImage, uploadsBaseURL, showActions = true }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {products.map((p) => (
                <ProductCard
                    key={p.id}
                    product={{
                        id: p.id,
                        name: p.name || p.product_name || '',
                        image: resolveProductImageUrl(p.image_url || p.image),
                        stock: typeof p.stock === 'number' ? p.stock : (typeof p.quantity === 'number' ? p.quantity : 0),
                        description: p.description || p.product_description || '',
                        price: typeof p.price === 'number' && p.price > 0 ? p.price : '',
                        category: p.category || 'Others',
                    }}
                    onEdit={showActions ? () => onEdit(p) : undefined}
                    onDelete={showActions ? () => onDelete(p) : undefined}
                    showActionsOnly={showActions}
                    showQuantityControl={showActions}
                    showOutOfStockLabel={false}
                    showBranchWarehouseLabels={false}
                    showUnitType={true}
                    unitType={p.unit_type}
                    onPreviewImage={() => onPreviewImage?.(p)}
                />
            ))}
        </div>
    );
}
